// extracted by mini-css-extract-plugin
export default {"chartList":"Index-module__chartList--Pihu4","chartListItem":"Index-module__chartListItem--_AVmp","titleContainer":"Index-module__titleContainer--przZB"};